import type { FunnelTemplateRouter } from "replo-publisher/src/trpc/routers/funnelTemplate";

import { createTrpcRouterConfig } from "@v2/trpc/config";
import { getNamespacedQueryClient } from "@v2/trpc/trpc";

const {
  router: funnelTemplateRouter,
  client: funnelTemplateClient,
  utils: funnelTemplateUtils,
  options: funnelTemplateOptions,
} = createTrpcRouterConfig<FunnelTemplateRouter>({
  path: "funnelTemplate",
  queryClient: getNamespacedQueryClient("funnelTemplate"),
});

export {
  funnelTemplateClient,
  funnelTemplateRouter,
  funnelTemplateUtils,
  funnelTemplateOptions,
};
